import { createRoot } from 'react-dom/client';

import AppRoot from './AppRoot';
import { getCurrentPagePath, updatePageSessionFromWebVital } from './hooks/analytics';
import reportWebVitals from './reportWebVitals';

export const mountApp = (rootElement: HTMLElement | null): void => {
  if (rootElement) {
    createRoot(rootElement).render(<AppRoot />);
  }

  reportWebVitals((metric) => {
    const pagePath = getCurrentPagePath() ?? window.location.pathname;
    updatePageSessionFromWebVital(metric.name, metric.value, pagePath);
  });
};

if (process.env.NODE_ENV !== 'test') {
  mountApp(document.getElementById('root'));
}
